export const SIZE_STUB = { width: 300, height: 80 };

export const INITIAL_SIZE_FRAME = { width: 500, height: 500 };
export const MIN_SIZE_FRAME = { width: 320, height: 250 };
export const MAX_SIZE_FRAME = { width: 2000, height: 2000 };

export const INITIAL_SIZE_EDIT = { width: 240, height: 200 };
export const MIN_SIZE_EDIT = { width: 240, height: 200 };
export const MAX_SIZE_EDIT = { width: 400, height: 300 };

export const SUMMARY_SIZE = {
  width: 500,
  height: 300,
};

export const SUMMARY_WITH_IMAGE_SIZE = {
  width: 500,
  height: 440,
};
